import {MultiSelect} from "primereact/multiselect"

const FilterMultiSelect = ({inputId, label, value, options, onChange}) => (
    <div className="col-lg-3 col-md-6">
        <div className="d-flex flex-column">
            <label htmlFor={inputId} className="fs-6 form-label fw-bold text-dark">
                {label}
            </label>
            <MultiSelect
                inputId={inputId}
                value={value}
                options={options}
                onChange={(event) => onChange(event.value)}
                placeholder="All"
                display="chip"
                showClear
                className="w-100"
                ptOptions={{mergeProps: true}}
                pt={{
                    token: {className: "bg-primary text-light"},
                    removeTokenIcon: {className: "text-light"},
                }}
            />
        </div>
    </div>
)

export default FilterMultiSelect
